import { PersonModel } from '../../models/personModel';

export const GET_PERSON_PROFILE_REQ = '@@profile/GET_PERSON_PROFILE_REQ';
export const GET_PERSON_PROFILE_RES = '@@profile/GET_PERSON_PROFILE_RES';
export const UPDATE_PERSON_PROFILE_REQ = '@@profile/UPDATE_PERSON_PROFILE_REQ';
export const UPDATE_PERSON_PROFILE_RES = '@@profile/UPDATE_PERSON_PROFILE_RES';
export const FAILED_REQUEST = '@@profile/FAILED_REQUEST';

interface PersonProfileAction {
  type:
    | typeof GET_PERSON_PROFILE_REQ
    | typeof GET_PERSON_PROFILE_RES
    | typeof UPDATE_PERSON_PROFILE_REQ
    | typeof UPDATE_PERSON_PROFILE_RES;
  payload?: PersonModel;
}

export interface PersonProfileState {
  profile?: PersonModel;
  loading: boolean;
}

interface ErrorAction {
  type: typeof FAILED_REQUEST;
  payload: string;
}

export type PersonProfileTypes = PersonProfileAction | ErrorAction;
